import { Activity } from "lucide-react";
import type { ActivityRow } from "../types";
import {
  Card,
  CardHeader,
  Empty,
  initialsOf,
  SkeletonRow,
  timeAgo,
  ViewAllLink,
} from "./_shared";

type Props = {
  activities: ActivityRow[];
  isLoading?: boolean;
};

export function RecentActivityWidget({ activities, isLoading }: Props) {
  return (
    <Card>
      <CardHeader
        icon={
          <Activity
            className="h-4 w-4 text-[hsl(180,72%,30%)]"
            strokeWidth={1.5}
          />
        }
        title="Recent Activity"
        count={activities.length}
        action={<ViewAllLink href="/admin/audit" />}
      />
      {isLoading ? (
        <div>
          {[0, 1, 2, 3].map((i) => (
            <SkeletonRow key={i} />
          ))}
        </div>
      ) : activities.length === 0 ? (
        <Empty
          icon={
            <Activity
              className="h-8 w-8 text-muted-foreground opacity-40"
              strokeWidth={1.5}
            />
          }
          text="No recent activity"
        />
      ) : (
        <ul className="divide-y" style={{ borderColor: "hsl(210,30%,92%)" }}>
          {activities.slice(0, 8).map((a) => (
            <li
              key={a.id}
              className="flex items-center gap-2 py-2"
            >
              <span
                className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[10px] font-semibold"
                style={{
                  background: "hsl(210,55%,92%)",
                  color: "hsl(210,100%,28%)",
                }}
              >
                {initialsOf(a.performedByName ?? "??")}
              </span>
              <div className="min-w-0 flex-1">
                <div className="truncate text-[13px] text-foreground">
                  {a.description ??
                    `${a.action} ${a.entityLabel ?? a.entityType}`}
                </div>
                <span
                  className="inline-flex rounded px-1.5 py-0.5 text-[10px] text-muted-foreground"
                  style={{ background: "hsl(210,16%,93%)" }}
                >
                  {a.entityType}
                </span>
              </div>
              <span className="shrink-0 text-[11px] text-muted-foreground">
                {timeAgo(a.createdAt)}
              </span>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
